import { render, staticRenderFns } from "./LayoutManager.vue?vue&type=template&id=0ff2f726&scoped=true"
import script from "./LayoutManager.vue?vue&type=script&lang=js"
export * from "./LayoutManager.vue?vue&type=script&lang=js"
import style0 from "./LayoutManager.vue?vue&type=style&index=0&id=0ff2f726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff2f726",
  null
  
)

export default component.exports